import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIPictureVideo',
    props: {
        src: {},
        width: {},
        height: {},
        poster: {},
        autoplay: { type: Boolean },
        loop: { type: Boolean },
        muted: { type: Boolean },
        border: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_UIVideo = _resolveComponent("UIVideo");
            const _component_UIPicture = _resolveComponent("UIPicture");
            return (_openBlock(), _createBlock(_component_UIPicture, {
                class: "UIPictureVideo",
                src: _ctx.poster,
                width: _ctx.width,
                height: _ctx.height,
                border: _ctx.border
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_UIVideo, {
                        class: "relative",
                        src: _ctx.src,
                        width: _ctx.width,
                        height: _ctx.height,
                        autoplay: _ctx.autoplay,
                        loop: _ctx.loop,
                        muted: _ctx.muted
                    }, null, 8, ["src", "width", "height", "autoplay", "loop", "muted"])
                ]),
                _: 1
            }, 8, ["src", "width", "height", "border"]));
        };
    }
});
